package com.eladfinish.bible.contest.screens.names.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.screens.names.NamesAction
import com.eladfinish.bible.contest.screens.names.NamesState
import com.eladfinish.bible.contest.screens.names.ui.ChapterDialog
import com.eladfinish.bible.contest.ui.components.dialogs.MenuData
import com.eladfinish.bible.contest.ui.components.dialogs.MenuDialog
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.Raw
import dev.icerock.moko.resources.desc.StringDesc

@Composable
internal fun NamesDialogs(
    dialogState: NamesState.DialogState,
    onAction: (NamesAction) -> Unit,
) {
    when (dialogState) {
        is NamesState.DialogState.ChapterDialog -> {
            ChapterDialog(
                chapterData = dialogState.chapterData,
                onDismiss = {
                    onAction(NamesAction.HideDialog)
                },
            )
        }

        is NamesState.DialogState.MenuDialog -> {
            val referenceMenuData = MenuData(
                title = StringDesc.Raw(dialogState.name),
                items = dialogState.nameReferences,
            )
            val title = referenceMenuData.title.localized()
            MenuDialog(
                menuData = referenceMenuData,
                onItemClick = { _, nameReference ->
                    onAction(
                        NamesAction.NameReferenceSelected(
                            name = title,
                            nameReference = nameReference,
                        )
                    )
                },
                onDismiss = {
                    onAction(NamesAction.HideDialog)
                },
            )
        }

        NamesState.DialogState.None -> Unit
    }
}
